import { router } from '@/plugins/1.router'
import { store } from '@/plugins/2.pinia'
import { useAuthStore } from '@/stores/auth'
import { resolveRoleRedirect } from '@/utils/roleRoutes'
import { normalizeRole } from '@/utils/roles'
import { setActivePinia, storeToRefs } from 'pinia'

const isPublicRoute = route => route.matched.some(record => record.meta?.public)

export default function () {
  router.beforeEach(async (to, _from, next) => {
    // Ensure the shared Pinia instance is active
    setActivePinia(store)

    const authStore = useAuthStore(store)
    const { isAuthenticated, currentUser, accessToken, userRole } = storeToRefs(authStore)

    console.log('[auth-guard] beforeEach', {
      to: to.fullPath,
      isAuthenticated: isAuthenticated?.value,
      tokenLen: accessToken?.value ? String(accessToken.value).length : 0,
      hasUser: Boolean(currentUser?.value),
    })

    if (isPublicRoute(to))
      return next()

    if (isAuthenticated?.value) {
      if (!currentUser?.value && accessToken?.value) {
        try {
          await authStore.fetchAuthenticatedUser()
          console.log('[auth-guard] user fetched ok')
        }
        catch (error) {
          console.error('Failed to fetch authenticated user', error)
          authStore.clearAuthState()
          
          return next({ name: 'login', query: { redirect: to.fullPath } })
        }
      }

      const requiredRoles = to.matched
        .map(record => record.meta?.roles)
        .flat()
        .filter(Boolean)

      if (requiredRoles.length) {
        const allowed = requiredRoles.map(role => normalizeRole(role))
        const roleValue = normalizeRole(userRole.value || currentUser.value?.role)

        if (!roleValue || !allowed.includes(roleValue)) {
          if (!roleValue) {
            console.warn('[auth-guard] missing role for authenticated user; clearing auth state', {
              to: to.fullPath,
              requiredRoles: allowed,
              suggestion: 'Check /api/auth/user payload and user role mapping. Retry login on /login without redirect query.',
            })
            authStore.clearAuthState()

            return next({ name: 'login', query: { redirect: to.fullPath } })
          }

          const fallbackTarget = resolveRoleRedirect(roleValue)

          console.warn('[auth-guard] route not allowed for current role; redirecting to role dashboard', {
            to: to.fullPath,
            role: roleValue,
            requiredRoles: allowed,
            fallbackTarget,
            suggestion: 'Open /login without ?redirect=... or clear stale redirect query before login.',
          })

          return next(fallbackTarget)
        }
      }

      console.log('[auth-guard] proceed to', to.fullPath)
      
      return next()
    }

    console.log('[auth-guard] redirecting to login', to.fullPath)
    
    return next({ name: 'login', query: { redirect: to.fullPath } })
  })
}
